import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import { action } from "mobx";
import { observer } from "mobx-react";
import { useViewState } from "../Context";
import ModalPopup from "./ModalPopup";
import Tabs from "./Tabs";
import Text from "../../Styled/Text";
import Box from "../../Styled/Box";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ExplorerWindowElementName = "AddData";
export default observer(function ExplorerWindow() {
  const viewState = useViewState();
  const theme = useTheme();
  const onClose = action(() => {
    viewState.closeCatalog();
    viewState.switchMobileView("nowViewing");
  });
  const onStartAnimatingIn = action(() => {
    viewState.explorerPanelAnimating = true;
  });
  const onDoneAnimatingIn = action(() => {
    viewState.explorerPanelAnimating = false;
  });
  const isVisible = !viewState.useSmallScreenInterface && !viewState.hideMapUi && viewState.explorerPanelIsVisible;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(ModalPopup, {
    viewState: viewState,
    isVisible: isVisible,
    isTopElement: viewState.topElement === ExplorerWindowElementName,
    onClose: onClose,
    onStartAnimatingIn: onStartAnimatingIn,
    onDoneAnimatingIn: onDoneAnimatingIn,
    children: [/*#__PURE__*/_jsx(_StyledBox, {
      paddedRatio: 4,
      fullWidth: true,
      $_css: theme.dark,
      $_css2: theme.radiusXL,
      $_css3: theme.radiusXL,
      children: /*#__PURE__*/_jsx(_StyledText, {
        extraExtraLarge: true,
        textLight: true,
        children: t("addData.dataCatalogue")
      })
    }), /*#__PURE__*/_jsx(Tabs, {
      terria: viewState.terria,
      viewState: viewState
    })]
  });
});
var _StyledBox = _styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          background: ", ";\n          border-radius: ", " ", " 0 0;\n        "])), p => p.$_css, p => p.$_css2, p => p.$_css3);
var _StyledText = _styled2(Text).withConfig({
  displayName: "ExplorerWindow___StyledText",
  componentId: "sc-1ffl2d3-0"
})({
  fontWeight: 500
});